import React from 'react'
import styled, { keyframes } from 'styled-components'
import {
	LOGO_FIRST_COLOR,
	LOGO_CENTER_COLOR,
	LOGO_LAST_COLOR,
} from '../../styles/colors.style'
import Browser from '../../services/Browser'

const animateColor = keyframes`
    from { background-color: #FFF; }
    to { background-color: ; }
`

const StyledLogo = styled.div`
	align-items: center;
	display: inline-flex;
	height: 60px;
	overflow: hidden;
	padding-left: 10px;
	position: relative;
	width: 55px;

	& > :first-child {
		margin-right: 20px;
	}

	.first-color {
		background-color: ${LOGO_FIRST_COLOR};
	}

	.center-color {
		background-color: ${LOGO_CENTER_COLOR};
	}

	.last-color {
		background-color: ${LOGO_LAST_COLOR};
	}

	${({ animate }) =>
		animate &&
		`.first-color,
	.center-color,
	.last-color {
		animation: ${animateColor} 0.6s infinite;
		animation-direction: alternate;
	}`} .logo-bar-center {
		overflow: hidden;
		height: 44px;
		position: absolute;
		width: 36px;
		display: flex;
		justify-content: center;
		align-items: center;

		${Browser.isIE()
			? `
            top: 50%;
            left: 62%;
            transform: translate(-50%, -50%);
            display: block;
        `
			: null};
	}

	.logo-bar-inner {
		width: 8px;
		height: 100px;
		transform-origin: 50%;
		transform: rotate(15deg);
	}
`

const StyledLogoContainer = styled.div`
	text-align: center;
	max-height: 58px;
	transform: scale(0.65);
`

export default function Logomark(props) {
	return (
		<StyledLogoContainer className="logo">
			<StyledLogo {...props}>
				<div className="logo-bar-inner first-color" />
				<div className="logo-bar-center">
					<div className="logo-bar-inner center-color" />
				</div>
				<div className="logo-bar-inner last-color" />
			</StyledLogo>
		</StyledLogoContainer>
	)
}
